// set to default in hillstowe env - uses old webfeed and not webconnect
const defaultConfig = require("./config.default.js");

module.exports = {
  ...defaultConfig,

  projectName: "Hillstowe",

  webfeedDebuggerWebsiteUrl:
    "https://hillstowe.avid.com.au/now-selling/land-for-sale/#/",
  webfeedConfig: {
    mode: "masterplan", // masterplan, feed
    type: "land" // land, packages, dwellings etc
  }
  // add other conf items below if needed
};
